import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActionsBar = ({ selectedCount, onBulkAction, onClearSelection }) => {
  const bulkActionOptions = [
  { value: '', label: 'Sélectionner' },
  { value: 'activate', label: 'Activer la sélection' },
  { value: 'deactivate', label: 'Désactiver la sélection' },
  { value: 'change-role', label: 'Changer le rôle' },
  { value: 'delete', label: 'Supprimer la sélection' }
  ];

  const [selectedAction, setSelectedAction] = React.useState('');

  const handleApplyAction = () => {
    if (selectedAction) {
      onBulkAction(selectedAction);
      setSelectedAction('');
    }
  };

  if (selectedCount === 0) return null;

  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-semibold">
            {selectedCount}
          </div>
          <div>
            <p className="text-sm font-semibold text-foreground">
              {selectedCount} user{selectedCount !== 1 ? 's' : ''} sélectionné
            </p>
            <p className="text-xs text-muted-foreground">
           Choisissez une action à appliquer aux utilisateurs sélectionnés
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3 w-full sm:w-auto">
          <div className="flex-1 sm:w-64">
            <Select
              options={bulkActionOptions}
              value={selectedAction}
              onChange={setSelectedAction}
              placeholder="Select action"
            />
          </div>
          <Button
            variant="default"
            onClick={handleApplyAction}
            disabled={!selectedAction}
            iconName="Check"
            iconPosition="left"
            iconSize={16}
          >
            Appliquer
          </Button>
          <Button
            variant="ghost"
            onClick={onClearSelection}
            iconName="X"
            iconSize={16}
          >
            <span className="sr-only">Effacer la sélection</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;